import { WalletPosition } from "@/api/positions/types";
import { Balance, Value } from "@/ui/formats";

const PositionProgressBar = ({
  tokenPosition,
}: {
  tokenPosition: WalletPosition | undefined;
}) => {
  const percent =
    ((tokenPosition?.balance ?? 0) / (tokenPosition?.max_balance ?? 1)) * 100;

  return (
    <div className="w-full mt-[0.938rem]">
      <div className="flex justify-between items-center">
        <Value
          value={(tokenPosition?.balance ?? 0) * (tokenPosition?.priceUsd ?? 0)}
          withSign={false}
          inherited="grey"
        />
        <span className="text-xs inline-flex items-center">
          <Balance value={percent} />%
        </span>
      </div>
      <div className="w-full relative h-[0.125rem] bg-blue bg-opacity-25">
        <div
          className="absolute left-0 top-0 bottom-0 bg-blue"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
};

export default PositionProgressBar;
